import React, { memo } from "react";
import { PLAYER_HEADSHOT_FALLBACK } from "../../config/constants";

const Headshot = memo(function Headshot({ src, name }) {
  return (
    <div className="h-10 w-10 shrink-0 overflow-hidden rounded-full bg-gray-100 ring-1 ring-gray-200">
      <img
        src={src || PLAYER_HEADSHOT_FALLBACK}
        alt={name || "Player"}
        className="h-full w-full object-cover object-top"
        onError={(e) => {
          if (e.currentTarget.src !== PLAYER_HEADSHOT_FALLBACK) {
            e.currentTarget.src = PLAYER_HEADSHOT_FALLBACK;
          }
        }}
        loading="lazy"
      />
    </div>
  );
});

const capitalizePosition = (position) => {
  if (!position) return "";
  return String(position).split("/")[0].split(",")[0].trim().toUpperCase();
};

export const PitchingLineup = ({ lineup, teamName }) => {
  if (!lineup || lineup.length === 0) {
    return (
      <div className="text-sm text-gray-500 italic">No pitching lineup data available</div>
    );
  }

  const sorted = [...lineup].sort((a, b) => {
    const orderA = a.pitch_order || 999;
    const orderB = b.pitch_order || 999;
    return orderA - orderB;
  });

  return (
    <div className="space-y-3">
      <h3 className="text-lg font-semibold text-gray-900 pb-2 border-b border-gray-200">{teamName} Pitchers</h3>
      <div className="space-y-1">
        {sorted.map((player, idx) => (
          <div
            key={idx}
            className="flex items-center gap-3 rounded-lg border border-gray-100 bg-white py-2 px-3"
          >
            <div className="w-6 text-center text-sm font-semibold text-gray-400">{player.pitch_order || idx + 1}</div>
            <Headshot src={player.headshot_url} name={player.player_name} />
            <div className="min-w-0 flex-1">
              <div className="flex items-center gap-2">
                <div className="font-medium text-gray-900 text-sm">
                  {player.player_name || "Unknown Player"}
                </div>
                <span className="text-xs text-gray-500">
                  {capitalizePosition(player.position)}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
